<template>
    <fragment>
        <label v-if="label.length > 0" :class="labelClass">{{ displayLabel }}</label>

        <div v-if="this.$slots.append" class="input-group">
            <input
                ref="input"
                v-model="data"
                :class="classNames"
                :disabled="disabled"
                :name="name"
                :readonly="readonly"
                :type="type"
                :data-cy="dataCy"
            />
            <span class="input-group-append">
                <slot name="append"></slot>
            </span>
        </div>
        <input
            v-else
            ref="input"
            v-model="data"
            :class="classNames"
            :disabled="disabled"
            :name="name"
            :readonly="readonly"
            :type="type"
            :data-cy="dataCy"
        />
        <InputErrors :errors="errors" :multiple="multipleErrors"/>
    </fragment>
</template>

<script>
import {Fragment} from "vue-fragment";
import InputErrors from "./InputErrors";

export default {
    components: {
        InputErrors,
        Fragment,
    },
    props: {
        label: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "text",
        },
        name: {
            type: String,
            default: "",
        },
        classNames: {
            type: String,
            default: "",
        },
        dataCy: {
            type: String,
            default: "",
        },
        errors: {
            type: Array,
            default: () => [],
        },
        labelClass:{
          type: String,
          default: ''
        },
        multipleErrors: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        mask: {
            type: String,
            default: null,
        },
        value: {},
    },
    computed: {
        data: {
            get: function () {
                return this.value;
            },
            set: function (value) {
                this.$emit("input", value);
            },
        },
        maskFunction() {
            switch (this.mask) {
                case 'quantity':
                    return 'maskQuantity';
                case 'money':
                    return 'maskMoney';
                case 'integer':
                    return 'maskInteger';
                case 'percentages':
                    return 'maskPercentages';
                case 'percentagesBelow100':
                    return 'maskPercentagesBelow100';
                default:
                    return '';
            }

        },
        displayLabel() {
            const requiredDesignation = this.required ? '*' : '';
            return this.label + requiredDesignation;
        }
    },
    mounted() {
        if (this.mask) {
            const input = $(this.$refs.input);
            input[this.maskFunction]();
            input.on('change', ({target}) => this.data = $(target).money().toFloat());
        }
    },
};
</script>
